import React, { useState } from 'react'

import { Popover } from "@mui/material"
import { showSnackBar } from "../../../../components/Snackbar/Snackbar"
import PopoverItem from "./PopoverItem"
import {
  changePaymentStatusFetch,
  reschedulePaymentFetch,
} from "../../../../features/payment/paymentSlice"
import MarkPaymentStatusModal from "../../../../components/PaymentModals/MarkPaymentStatusModal"
import ReschedulePaymentModal from "../../../../components/PaymentModals/ReschedulePaymentModal"
import { useMyContextLoading } from "../../../../components/LoadingContextProvider/LoadingContextProvider"
import { useDispatch, useSelector } from "react-redux"
import { selectFeatureFlag } from "../../../../features/featureFlags/selectors"
import { isRescheduleBlocked } from "../../../../utils/gatewayResponse"
import { useUiKit } from "../../../../components/UiKit/UiKitContext"

const PaymentPopover = ({
  id,
  open,
  anchorEl,
  handleClose,
  setOpenEdit,
  paymentId,
  data,
  setOpenChangeStatus,
  trigger
}) => {
  const dispatch = useDispatch()
  const { triggerLoading } = useMyContextLoading()
  const { button: kitButton } = useUiKit()
  const currentPayment = data?.find(el => (el.id || el._id) === paymentId)
  const currentStatus = currentPayment?.statusObj?.value
  console.log('paymentId:', paymentId)
  console.log('data:', data)
  if (Array.isArray(data)) {
    console.log('data ids:', data.map(el => ({ id: el.id, _id: el._id, status: el.status })))
    const found = data.find(el => (el.id || el._id) === paymentId)
    console.log('found payment:', found)
  } else {
    console.log('data is not an array')
  }
  console.log('currentPayment:', currentPayment)
  console.log('currentStatus:', currentStatus)

  const processPayment = async () => {
    console.log('paymentId = ', paymentId)
    console.log('data = ', data)
    if (currentPayment) {
      const isPaidOrProcessing = ['processing', 'paid'].includes(currentPayment.status)
      if (!isPaidOrProcessing) {
        setOpenChangeStatus(true)
      } else {
        showSnackBar("error", "Payment can't be changed as the Payment has been already sent to Gateway ")
      }
    }
  }

  // Terminal marks (Paid/Failed) go through a confirmation modal that suggests
  // processedAt = the payment's due date and collects optional transaction id /
  // reason fields; non-terminal marks stay one-click.
  const [markMode, setMarkMode] = useState(null)

  // WS 2074858. A declined payment can be rescheduled once: after that its retry is the attempt to
  // reschedule. The server enforces the same rules.
  const rescheduleEnabled = useSelector(selectFeatureFlag('PAYMENT_RESCHEDULE'))
  const hasRetry = Array.isArray(data) && data.some(el => el.rescheduledFrom === paymentId)
  // Never on a return the bank says must not be debited again (the same rule the server applies).
  const canReschedule = rescheduleEnabled && currentStatus === 'failed' && !hasRetry && !isRescheduleBlocked(currentPayment?.transactionData)
  const [rescheduling, setRescheduling] = useState(false)

  const reschedule = async ({ dueDate }) => {
    triggerLoading(true)
    try {
      const result = await dispatch(reschedulePaymentFetch({ paymentId, dueDate }))
      if (result?.error) {
        showSnackBar("error", result?.payload || 'Failed to reschedule the payment')
      } else {
        showSnackBar("success", "Payment rescheduled")
        trigger()
      }
    } catch (error) {
      showSnackBar('error', 'An unexpected error occurred. Please try again.')
    }
    triggerLoading(false)
  }

  const changePaymentStatus = async ({ value = '', ...fields }) => {
    triggerLoading(true)
    try {
      let result = await dispatch(changePaymentStatusFetch({ paymentId, value, ...fields }))
      console.log(result)
      if (result?.payload?.data?._id) {
        showSnackBar("success", "The payment is being processed")
      } else if (result.error) {
        const errorMessage = result?.payload || 'An error occurred. Please try again.'
        showSnackBar("error", errorMessage)
      }

      trigger()
    } catch (error) {
      console.log(error)

      showSnackBar('error', 'An unexpected error occurred. Please try again.')
    }
    triggerLoading(false)
  }

  const changePaymentStatusOrThrow = async ({ value = '', ...fields }) => {
    const result = await dispatch(changePaymentStatusFetch({ paymentId, value, ...fields }))
    if (result?.error) {
      const errorMessage = result?.payload || 'An error occurred. Please try again.'
      showSnackBar("error", errorMessage)
      throw new Error('not changed')
    }
    if (result?.payload?.data?._id) showSnackBar("success", "The payment is being processed")
    trigger()
  }

  return (
    <>
    <Popover
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    >
      <div className="flex flex-col justify-center items-start w-[9.5rem] rounded-md bg-paper border border-divider py-2">

        <PopoverItem title='Edit' onClick={() => setOpenEdit(true)} withBreakLine={false} />

        {/* WS 2074858. A rescheduled payment is changed through its latest attempt; the server
            refuses a charge or a status change here (except keeping it failed). */}
        {!hasRetry && !(currentStatus === 'processing' || currentStatus === 'cleared') && (
          console.log('Show "Process via selected payment processor"', data?.find(el => el.id === paymentId)?.status),
          <PopoverItem title={'Process via "selected payment processor"'} onClick={processPayment} />
        )}
        {!hasRetry && currentStatus !== 'cleared' && (
          <PopoverItem title={'Mark as "Cleared"'} onClick={() => setMarkMode('cleared')} />
        )}
        {!hasRetry && currentStatus !== 'processing' && (
          console.log('Show "Mark as Processing"', currentStatus),
          <PopoverItem title={'Mark as "Processing"'} onClick={() => changePaymentStatus({ value: 'processing' })} />
        )}
        {!hasRetry && currentStatus !== 'scheduled' && (
          console.log('Show "Mark as Pending"', currentStatus),
          <PopoverItem title={'Mark as "Pending"'} onClick={() => changePaymentStatus({ value: 'scheduled' })} />
        )}
        {currentStatus !== 'failed' && (
          console.log('Show "Mark as Failed"', currentStatus),
          <PopoverItem title={'Mark as "Failed"'} onClick={() => setMarkMode('failed')} />
        )}
        {canReschedule && (
          <PopoverItem title="Reschedule" onClick={() => setRescheduling(true)} />
        )}

      </div>

    </Popover>

    {/* Sibling of the Popover, NOT a child — the popover may close (click-away)
        while the operator is still filling the modal in. */}
    {markMode && (
      <MarkPaymentStatusModal
        open={!!markMode}
        mode={markMode}
        payment={currentPayment}
        onClose={() => setMarkMode(null)}
        onConfirm={(fields) => {
          const value = markMode
          if (kitButton) return changePaymentStatusOrThrow({ value, ...fields })
          setMarkMode(null)
          changePaymentStatus({ value, ...fields })
        }}
      />
    )}
    {rescheduling && (
      <ReschedulePaymentModal
        open={rescheduling}
        payment={currentPayment}
        payments={data}
        onClose={() => setRescheduling(false)}
        onConfirm={(fields) => {
          setRescheduling(false)
          reschedule(fields)
        }}
      />
    )}
    </>
  )
}

export default PaymentPopover
